import { useState } from "react";
import { X, Sparkles } from "lucide-react";
import api from "../../services/api";

var EVENT_TYPES = [
  { value: "feira", label: "Feira / Evento" },
  { value: "jantar", label: "Jantar Especial" },
  { value: "palestra", label: "Palestra" },
  { value: "treinamento", label: "Treinamento" },
  { value: "outro", label: "Outro" },
];

var VISIBILITY_OPTIONS = [
  { value: "publico", label: "Visivel para todos" },
  { value: "pessoal", label: "Apenas minha agenda" },
];

export default function EventModal({ onClose, onSave, editEvent }) {
  var titleState = useState(editEvent ? editEvent.title : "");
  var descState = useState(editEvent ? (editEvent.description || "") : "");
  var typeState = useState(editEvent ? editEvent.event_type : "outro");
  var startState = useState(editEvent ? editEvent.start_date : "");
  var endState = useState(editEvent ? (editEvent.end_date || "") : "");
  var visState = useState(editEvent ? editEvent.visibility : "publico");
  var loadingState = useState(false);
  var errorState = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!titleState[0].trim() || !startState[0]) return;
    loadingState[1](true);
    errorState[1](null);
    try {
      var payload = {
        title: titleState[0].trim(),
        description: descState[0].trim() || null,
        event_type: typeState[0],
        start_date: startState[0],
        end_date: endState[0] || null,
        visibility: visState[0],
      };
      if (editEvent) {
        await api.put("/events/" + editEvent.id, payload);
      } else {
        await api.post("/events", payload);
      }
      onSave();
    } catch (err) {
      var d = err.response ? err.response.data : null;
      var detail = d ? d.detail : "Erro ao salvar evento";
      errorState[1](typeof detail === "string" ? detail : "Erro ao salvar evento");
    } finally {
      loadingState[1](false);
    }
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed bottom-0 left-0 right-0 sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 z-50 sm:max-w-md sm:w-full" data-testid="event-modal">
        <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <div className="p-2 bg-violet-100 rounded-lg"><Sparkles className="w-5 h-5 text-violet-700" /></div>
              <h2 className="text-lg font-bold text-[#0A2F3D]">{editEvent ? "Editar Evento" : "Novo Evento"}</h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          {errorState[0] && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Titulo do Evento *</label>
              <input type="text" value={titleState[0]} onChange={function (e) { titleState[1](e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-violet-500/30 focus:border-violet-500"
                placeholder="Ex: FEMEC 2026" required data-testid="event-form-title" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Tipo</label>
                <select value={typeState[0]} onChange={function (e) { typeState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-violet-500/30"
                  data-testid="event-form-type">
                  {EVENT_TYPES.map(function (t) { return <option key={t.value} value={t.value}>{t.label}</option>; })}
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Visibilidade</label>
                <select value={visState[0]} onChange={function (e) { visState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-violet-500/30"
                  data-testid="event-form-visibility">
                  {VISIBILITY_OPTIONS.map(function (v) { return <option key={v.value} value={v.value}>{v.label}</option>; })}
                </select>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Data Inicio *</label>
                <input type="date" value={startState[0]} onChange={function (e) { startState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-violet-500/30"
                  required data-testid="event-form-start" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Data Fim</label>
                <input type="date" value={endState[0]} onChange={function (e) { endState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-violet-500/30"
                  data-testid="event-form-end" />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Descricao</label>
              <textarea value={descState[0]} onChange={function (e) { descState[1](e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-violet-500/30"
                rows="2" placeholder="Detalhes do evento..." data-testid="event-form-desc" />
            </div>
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loadingState[0]}
                className="flex-1 px-4 py-2.5 bg-violet-600 text-white rounded-xl text-sm font-medium hover:bg-violet-700 disabled:opacity-50" data-testid="event-form-submit">
                {loadingState[0] ? "Salvando..." : (editEvent ? "Salvar" : "Criar Evento")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
